import script from "./PatientBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientBar.vue?vue&type=script&setup=true&lang=js"

import "./PatientBar.vue?vue&type=style&index=0&id=33452b67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33452b67"]])

export default __exports__